import Breadcrumb from 'components/Content/Breadcrumb/Breadcrumb';

export default Breadcrumb;
